<div>
  <span class="async-label">
    <ng-content></ng-content>
  </span>
  <mat-spinner class="async-spinner" [diameter]="15">
  </mat-spinner>
</div>
